import { FETCH_LANDINGS } from "./mutation-types";

export default {
  [FETCH_LANDINGS](state, data) {
    state.landings = data.data;
  },
};
